import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import LoadingContainer from '../ui/loading-container'

interface PublicOnlyRouteProps {
  children: React.ReactNode
}

const PublicOnlyRoute = ({ children }: PublicOnlyRouteProps) => {
  const { user, status } = useAppSelector((state) => state.auth)

  if (status === 'loading' || status === 'initial') {
    return <LoadingContainer />
  }

  if (user) {
    return <Navigate to="/my-lists" replace />
  }

  return <>{children}</>
}

export default PublicOnlyRoute
